var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`${_vm.$appPrefix}-h`, `${_vm.$appPrefix}-h--${_vm.theme}`, _vm.headingLineClass]},[_c(`h${_vm.size}`,{tag:"component",class:[_vm.headingClass]},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }